import "./App.css";
import InviteCodeLanding from "./InviteCodeLanding";
import { getClientJSClient } from "./fingerprint";
import { useEffect, useMemo, useState } from "react";

function App() {
  const [postResponse, setPostResponse] = useState(null);
  const [isBusy, setBusy] = useState(true);

  const clientJSHash = useMemo(
    () =>
      Object.getOwnPropertyNames(
        Object.getPrototypeOf(getClientJSClient())
      ).reduce((mp, method) => {
        const name = method.replace("get", "").replace("is", "");
        try {
          return {
            ...mp,
            [name]: getClientJSClient()[method](),
          };
        } catch (error) {
          return {
            ...mp,
            [name]: null,
          };
        }
      }, {}),
    []
  );

  useEffect(() => {
    const postSignature = async (clientJSHash) => {
      const addr = new URL(window.location.href);
      const routes = addr.pathname.split("/");
      const param = routes[1] ? routes[1] : "";

      let res;

      if (param === "check") {
        res = await fetch("/checkInvite", {
          method: "get",
          headers: { "Content-Type": "application/json" },
        });
      } else {
        res = await fetch("/registerInvite", {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            signature: clientJSHash["Fingerprint"],
            browser: clientJSHash["Browser"],
            os: clientJSHash["OS"],
            osVersion: clientJSHash["OSVersion"],
            inviteId: param,
          }),
        });
      }

      const json = await res.json();
      setPostResponse(json);
      setBusy(false);
    };

    postSignature(clientJSHash);
  }, [clientJSHash]);

  const isBrowserClient =
    clientJSHash["Opera"] ||
    clientJSHash["Chrome"] ||
    clientJSHash["Safari"] ||
    clientJSHash["Firefox"];

  if (isBusy) {
    return (
      <div className="invite-loading" id="waitDiv">
        <img src="/bars-rotate-fade.svg" alt="" />
      </div>
    );
  }

  if (postResponse && postResponse.show && postResponse.superCode) {
    const appStoreUrl =
      postResponse.type && postResponse.type > 1
        ? "https://apps.apple.com/app/apple-store/id1191453603?pt=118483814&ct=groups&mt=8"
        : "https://apps.apple.com/app/apple-store/id1191453603?pt=118483814&ct=invite&mt=8";

    return (
      <InviteCodeLanding
        inviterName={postResponse.inviterName}
        giftCode={postResponse.superCode}
        appStoreUrl={appStoreUrl}
      />
    );
  }

  if (!postResponse || postResponse.redirect || !postResponse.show) {
    const redirectUrl =
      postResponse && postResponse.type && postResponse.type > 1
        ? "https://apps.apple.com/app/apple-store/id1191453603?pt=118483814&ct=groups&mt=8"
        : "https://apps.apple.com/app/apple-store/id1191453603?pt=118483814&ct=invite&mt=8";

    if (isBrowserClient) {
      window.location.replace(redirectUrl);
    } else {
      let url = window.location.href;
      url = url
        .replace("https://spfy.cc", "superfy://spfy.cc")
        .replace("https://dev.spfy.cc", "superfydev://dev.spfy.cc");

      window.location.replace(url);
      setTimeout(function () {
        window.location.replace(redirectUrl);
      }, 1000);
    }

    return (
      <div className="invite-loading">
        <img src="/bars-rotate-fade.svg" alt="" />
      </div>
    );
  }
}

export default App;
